import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-file",
  "use": "icon-file-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol viewBox=\"0 0 22 22\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-file\">\n<path d=\"M17.875 8.25H12.375V2.75H4.125V19.25H17.875V8.25ZM17.3167 6.875L13.75 3.30825V6.875H17.3167ZM3.4375 1.375H13.75L19.25 6.875V19.9375C19.25 20.1383 19.1856 20.303 19.0568 20.4318C18.928 20.5606 18.7633 20.625 18.5625 20.625H3.4375C3.23675 20.625 3.07198 20.5606 2.94319 20.4318C2.8144 20.303 2.75 20.1383 2.75 19.9375V2.0625C2.75 1.86175 2.8144 1.69698 2.94319 1.56819C3.07198 1.4394 3.23675 1.375 3.4375 1.375ZM6.875 11H15.125V12.375H6.875V11ZM6.875 6.875H10.3125V8.25H6.875V6.875ZM6.875 15.125H15.125V16.5H6.875V15.125Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/svgIcon/svg/file.svg
// module id = EEEZ
// module chunks = 262